const sharedMobileDesktop = require('../pages/content/faq_'+language+'.js');

export default {
  large: [
    {
      name: 'FAQ',

      fixedSection: {
        sectionType: 'toc',
        data: {
          headline: sharedMobileDesktop.headline,
          index: sharedMobileDesktop.index,
          paging: false,
        },
      },

      sharedData: {
        currentSubSection: 0,
        scrollingPosition: null,
      },

      scrolledSection: {
        name: 'ExpandableFaq',
        sectionType: 'expandable-list',
        data: {
          active: null,
          expandableGroups: sharedMobileDesktop.list
        },
      },
    }
  ],
};



// WEBPACK FOOTER //
// ./pages/Faq.js